export enum ControleEstoqueResumoFiltroEnum {
  Todos = 0,
  Disponivel = 1,
  EstoqueBaixo = 2,
  EstoqueZerado = 3,
  Reservado = 4,
}
